import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import { getMonthlyWorkload } from '../../store/ducks/humanResources'

class WorkloadGraph extends Component {
  componentDidMount() {
    const { getMonthlyWorkload } = this.props
    getMonthlyWorkload()
  }

  render() {
    const {
      getMonthlyWorkloadIsLoading, getMonthlyWorkloadError, monthlyWorkload,
    } = this.props.humanResources

    if (getMonthlyWorkloadIsLoading) {
      return (
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">
              Carga horária mensal
            </h4>
            <div>
              <div id="line-column-chart" className="apex-charts" dir="ltr">
                Carregando...
              </div>
            </div>
          </CardBody>
        </Card>
      )
    }

    if (getMonthlyWorkloadError) return null

    if (!getMonthlyWorkloadIsLoading && !getMonthlyWorkloadError && monthlyWorkload) {
      const hoursBalanceData = monthlyWorkload
        .map(item => item.saldo)
        .reverse()
      const workloadData = monthlyWorkload
        .map(item => (item.percentual * 100).toFixed(0))
        .reverse()
      const labels = monthlyWorkload
        .map(item => item.mes)
        .reverse()

      const options = {
        labels,
        chart: {
          type: 'line',
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [0, 4],
          curve: 'smooth',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '40%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: ['#5664d2', '#1cbb8c'],
        yaxis: [{
          title: {
            text: 'Carga horária realizada (%)',
          },
        }, {
          opposite: true,
          title: {
            text: 'Saldo de horas no mês',
          },
        }],
      }

      const series = [{
        name: 'Carga horária realizada (%)',
        type: 'column',
        data: workloadData,
      }, {
        name: 'Saldo de horas',
        type: 'line',
        data: hoursBalanceData,
      }]

      return (
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">
              Carga horária mensal
            </h4>
            <div>
              <div id="line-column-chart" className="apex-charts" dir="ltr">
                <ReactApexChart
                  options={options}
                  series={series}
                  height="280"
                />
              </div>
            </div>
          </CardBody>
        </Card>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ getMonthlyWorkload }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(WorkloadGraph)
